import { Controller } from '@hotwired/stimulus'

// Triggers a top-level window.print() once the page has settled.
//
// The self check-in kiosk runs Microsoft Edge in Assigned Access kiosk mode.
// Its silent printing honours top-level print() calls but silently refuses a
// print issued from an iframe. So, unlike ui-auto-print-link (which prints a
// hidden iframe and is fine on ordinary desktops), this controller prints the
// current document directly; the host page is expected to reveal only the
// printable area via @media print.
export default class extends Controller {
  private connection = 0

  connect() {
    this.printWhenReady(++this.connection)
  }

  disconnect() {
    this.connection += 1
  }

  private async printWhenReady(connection: number) {
    await this.documentReady()
    await ((document.fonts && document.fonts.ready) || Promise.resolve())
    await Promise.all(this.receiptImages().map(image => image.decode?.().catch(() => undefined)))
    await this.nextPaint()
    await this.nextPaint()

    if (connection === this.connection) window.print()
  }

  private documentReady() {
    if (document.readyState === 'complete') return Promise.resolve()

    return new Promise<void>(resolve =>
      window.addEventListener('load', () => resolve(), { once: true })
    )
  }

  private receiptImages() {
    return [...document.querySelectorAll<HTMLImageElement>('#self-checkin-print-area img')]
  }

  private nextPaint() {
    return new Promise<void>(resolve => window.requestAnimationFrame(() => resolve()))
  }
}
